import { useCallback, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "./../../../../hooks";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Input, Modal } from "djuno-design";
import {
  handleToggleAiNotebookLabelModal,
  selectAiNotebookLabelEditor,
  selectAiNotebooksActionLoading,
  selectSelectedAiNotebook,
  updateAiNotebookAsync,
} from "../../../../store/ai/notebooks/notebooksSlice";
import { AiNotebookLabelSchema } from "../../../../utils/validations";
import { getAiNotebookAsync } from "../../../../store/ai/notebooks/notebookSlice";

const AiNotebookLabelModal = () => {
  const dispatch = useAppDispatch();
  const isOpen = useAppSelector(selectAiNotebookLabelEditor);
  const loading = useAppSelector(selectAiNotebooksActionLoading);

  const selectedNotebook = useAppSelector(selectSelectedAiNotebook);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(AiNotebookLabelSchema),
    shouldUnregister: true,
    reValidateMode: "onChange",
  });

  const onSubmit = (data: any) => {
    if (!loading && selectedNotebook) {
      const labels = {
        ...selectedNotebook.spec.labels,
        [data.key]: data.value,
      };

      dispatch(
        updateAiNotebookAsync({
          id: selectedNotebook.id,
          data: { labels },
        })
      ).then((action) => {
        if (action.type === "ai-notebooks/update/fulfilled") {
          handleOnClose();
          dispatch(
            getAiNotebookAsync({
              id: selectedNotebook.id,
            })
          );
        }
      });
    }
  };

  const handleOnClose = useCallback(() => {
    reset();
    dispatch(
      handleToggleAiNotebookLabelModal({ isOpen: false, notebook: null })
    );
  }, [dispatch, reset]);

  useEffect(() => {
    return () => {
      handleOnClose();
    };
  }, [handleOnClose]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleOnClose}
      contentClassName="max-w-lg"
      title="Add a label"
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="mt-5">
          <Input
            {...register("key")}
            error={errors.key?.message}
            placeholder=""
            label="Key"
            required
          />
        </div>
        <div className="mt-5">
          <Input
            label="Value"
            {...register("value")}
            error={errors.value?.message}
            className="text-xs"
            required
          />
        </div>

        <div className="mt-4 flex justify-end gap-2">
          <Button uiType="light" onClick={handleOnClose}>
            Cancel
          </Button>

          <Button uiType="primary" type="submit" loading={loading}>
            Add a label to the notebook
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default AiNotebookLabelModal;
